import {apiAction} from './helper';

export const GET_ENERGY_DATA = apiAction('GET_ENERGY_DATA');
export const GET_SIMULATE_ENERGY = apiAction('GET_SIMULATE_ENERGY');
export const CREATE_ENERGY_HEATMAP = 'CREATE_ENERGY_HEATMAP';
export const SET_ENERGY_REDUCER_PROPS = 'SET_ENERGY_REDUCER_PROPS';
